import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';

export const ECCheckboxField = props => {
  const { name, label, form, defaultValue, initial, ...rest } = props;

  const dv = valueByName(initial, name) || defaultValue || false;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => form.setValue(name, dv), []);

  return (
    <FormControlLabel
      control={
        <Controller
          control={form.control}
          name={name}
          defaultValue={dv}
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={field.value || false}
              inputProps={{
                'aria-label': 'primary checkbox',
              }}
              {...rest}
            />
          )}
        />
      }
      label={label}
    />
  );
};

ECCheckboxField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  form: PropTypes.object,
  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
